import {noticeCategories, NoticeCategory} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<NoticeCategory>;

export const NoticeCategorySelect = (props: Props) => {
  const {options = noticeCategories, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
